import { MYBH_LINK } from "@config/followTopic";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function MyBHMetaData(): PageMetaDataValues {
  const level2 = "mybh";

  const gaData: GADataProps = {
    level2: level2,
    title: "MyBH",
    section: level2,
    contentcat: "1",
    contenttype: "listing",
  };

  const metaTags: MetaTagsProps = {
    title: "MyBH | Beritaharian.sg",
    description: "MyBH - BeritaHarian.sg",
    slug: `/${MYBH_LINK}`,
  };

  return {
    gaData,
    metaTags,
  };
}
